// extracted by mini-css-extract-plugin
export default {"accept-drop":"TxVJF","acceptDrop":"TxVJF","reject-drop":"_2UGZQ","rejectDrop":"_2UGZQ"};